import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  initializeCart,
  setTokenInCookie,
  setUserInfo,
  toggleAuthentication,
} from "../../redux/hejalSlice";
import OtpInput from "react-otp-input";
import { useLocation } from "react-router-dom";

const VerifysignupOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const location = useLocation();
  const { email } = location.state || {};
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || otp.length !== 6) {
      setError("Enter a valid 6-digit OTP");
      return;
    }

    try {
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.VerifySignupOtp,
        data: { email, otp },
      });

      if (!response.success) {
        toast.error(response.message || "Invalid OTP, try again!");
        setError("Invalid OTP");
      } else {
        dispatch(setUserInfo(response?.data?.user));
        dispatch(
          setTokenInCookie({
            token: response.data.token,
            refreshToken: response.data.refreshToken,
          })
        );
        dispatch(toggleAuthentication());
        if (response.user?.cart) {
          dispatch(initializeCart(response.user.cart));
        }
        setSuccessMsg("OTP verified successfully! Redirecting...");
        toast.success("OTP verified!");
        setTimeout(() => navigate("/"), 0);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      toast.error("Something went wrong, try again.");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-[#efefef]">
      <div className="otp-box bg-[#fff] lg:min-h-[300px] lg:min-w-[400px] min-h-[200px] min-w-[300px] flex flex-col items-center justify-between py-5 px-8 gap-4">
        <div className="flex flex-col items-center">
          <h1 className="font-titleFont decoration-[1px] text-center font-semibold text-[20px] mdl:text-[28px] mb-4">
            Verify OTP
          </h1>

          <OtpInput
            value={otp}
            onChange={setOtp} // Properly updating the OTP state
            numInputs={6}
            renderSeparator={<span></span>}
            renderInput={(props) => (
              <input
                {...props}
                className="otp-input border border-gray-300 text-center w-12 h-12 text-xl"
              />
            )}
            inputStyle={{
              width: "50px",
              height: "50px",
              margin: "0 10px",
              fontSize: "20px",
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          />
          {error && <p className="text-red-500 mt-2">{error}</p>}
          {successMsg && <p className="text-green-500 mt-2">{successMsg}</p>}
        </div>

        <div className="w-full">
          <button
            onClick={handleVerifyOtp}
            className="mix-bg text-white px-6 py-2 w-full rounded-[8px] hover:bg-[#000] transition"
          >
            Submit OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifysignupOtp;
